<p-multiSelect
  [options]="officesResource.value() ?? []"
  [ngModel]="selectedOffices()"
  optionLabel="officeName"
  [placeholder]="'project.steps.systemRecording.offices.placeholder' | transloco"
  (ngModelChange)="selectionChange.emit($event)"
  class="w-full"
  [filter]="false"
  [showHeader]="false"
  appendTo="body"
  [disabled]="isReadOnly()"
>
  <ng-template #header>
    @if (showSelectAll()) {
      <div class="p-(--p-multiselect-list-padding)">
        <label
          [for]="selectAllInputId"
          class="flex items-center cursor-pointer gap-(--p-multiselect-option-gap) p-(--p-multiselect-option-padding)"
        >
          <p-checkbox
            [inputId]="selectAllInputId"
            [ngModel]="allSelected()"
            [binary]="true"
            (onChange)="onToggleAll($event.checked)"
          />
          <span>{{ 'multiselect.select.all' | transloco }}</span>
        </label>
      </div>
    }
  </ng-template>
</p-multiSelect>
